module.exports = __webpack_public_path__ + "img/EDS_120X35.3e096481.png";